<div class="profile-container" *transloco="let t">
  <h1 class="bold-24 margin-left-16">{{ t('profile') }}</h1>

  <div class="profile-card profile-header">
    @if (!user()) {
      <ngx-skeleton-loader class="loader" count="1" appearance="circle" [theme]="{width: '72px', height: '72px'}" />
    } @else {
      <app-user-avatar [avatarConfig]="user()?.avatarConfig" [username]="user()?.username" [size]="72" />
      <div class="header-details">
        <div class="bold-24">{{ user()?.username }}</div>
        <div class="regular-12 secondary-text-color">{{ user()?.email }}</div>
        <div class="leveling">
          <span class="semibold-14">{{ t('level') }} {{ user()?.leveling?.level }}</span>
          <div class="xp-bar">
            <div class="xp-bar-fill" [style.width.%]="xpPercentage()"></div>
          </div>
          <span class="regular-12 secondary-text-color">
            {{ user()?.leveling?.xp }} / {{ user()?.leveling?.xpToNextLevel }} XP
          </span>
        </div>
      </div>
    }
  </div>

  <div class="profile-card">
    <div class="semibold-16 section-title">{{ t('settings') }}</div>
    <form [formGroup]="form" (submit)="saveProfile()">
      <mat-form-field class="form-field" appearance="fill" color="accent" hideRequiredMarker="true">
        <mat-label>{{ t('username') }}</mat-label>
        <input matInput formControlName="username">
      </mat-form-field>
      <mat-form-field class="form-field" appearance="fill" color="accent" hideRequiredMarker="true">
        <mat-label>{{ t('firstName') }}</mat-label>
        <input matInput formControlName="firstName">
      </mat-form-field>
      <mat-form-field class="form-field" appearance="fill" color="accent" hideRequiredMarker="true">
        <mat-label>{{ t('lastName') }}</mat-label>
        <input matInput formControlName="lastName">
      </mat-form-field>
      <mat-form-field class="form-field" appearance="fill" color="accent" hideRequiredMarker="true">
        <mat-label>{{ t('phoneNumber') }}</mat-label>
        <input matInput formControlName="phoneNumber">
      </mat-form-field>
      <mat-form-field class="form-field" appearance="fill" color="accent">
        <mat-label>{{ t('email') }}</mat-label>
        <input matInput [value]="user()?.email || ''" disabled>
      </mat-form-field>
      <button class="primary-bar-btn" type="submit"
              [disabled]="form.invalid || !form.dirty || saving()">{{ t('save') }}</button>
    </form>
    <div class="margin-top-12">
      <mat-checkbox [checked]="searchable()" (change)="toggleSearchable($event.checked)">
        {{ t('findableBySearch') }}
      </mat-checkbox>
    </div>
  </div>

  <div class="profile-card legal-links">
    <a routerLink="/privacy-policy" target="_blank" class="general-text link-text">{{ t('privacyPolicy') }}</a>
    <a routerLink="/terms-and-conditions" target="_blank" class="general-text link-text">{{ t('termsOfUse') }}</a>
  </div>

  <div class="profile-card">
    <div class="semibold-16 section-title color-red">{{ t('dangerZone') }}</div>
    <div class="danger-zone-actions">
      <button class="secondary-bar-btn" type="button" (click)="logout()">{{ t('logout') }}</button>
      <button class="warning-bar-btn" type="button"
              (click)="showDeleteConfirmation.set(true)">{{ t('deleteAccount') }}</button>
    </div>
  </div>

  @if (showDeleteConfirmation()) {
    <app-modal [title]="t('deleteAccountQ')" [footerButtons]="deleteModalButtons"
               (closeEvent)="showDeleteConfirmation.set(false); deleteAllQuests.setValue(false)">
      <div class="text-color-soft margin-top-12">{{ t('delAcc1') }}</div>
      <div class="text-color-soft">{{ t('delAcc2') }}</div>
      <p>
        <mat-checkbox [formControl]="deleteAllQuests" color="warn">
          <span class="text-color-soft">{{ t('delAcc3') }}</span>
        </mat-checkbox>
      </p>
    </app-modal>
  }
</div>
